'use client';

import React from 'react';

const SystemSection = () => {
  const elements = [
    {
      number: '01',
      title: 'Leadership Alignment',
      description: 'Establishing shared understanding, commitment, and accountability at the executive level for continuous AI-driven change. This includes governance structures, decision-making frameworks, and leadership behaviours that sustain transformation momentum.',
    },
    {
      number: '02',
      title: 'Operating Model Adaptation',
      description: 'Redesigning organisational structures, processes, and workflows to enable rapid adoption and continuous evolution. This addresses how work is organised, how decisions are made, and how value is created in AI-augmented environments.',
    },
    {
      number: '03',
      title: 'Workforce Enablement',
      description: 'Building capability, confidence, and readiness across the organisation to work effectively with AI. This extends beyond training to include role redesign, career pathways, and cultural adaptation.',
    },
    {
      number: '04',
      title: 'Adoption Intelligence',
      description: 'Measuring, monitoring, and responding to adoption patterns in real-time. This provides visibility into where adoption is succeeding, where it is stalling, and what interventions are required to accelerate progress.',
    },
    {
      number: '05',
      title: 'Continuous Evolution',
      description: 'Embedding systems and practices that sustain transformation momentum as AI capabilities advance. This ensures organisations can adapt continuously rather than requiring repeated transformation initiatives.',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            The AI Change Leadership System™
          </h2>

          <div className="mb-12 space-y-6 text-lg text-gray-800 font-body leading-relaxed">
            <p>
              The AI Change Leadership System™ is a cross-sector reference model for leading continuous, organisation-wide transformation. It is not a client-specific delivery framework. It is a cross-sector reference model for defining emerging standards, practices, and leadership capabilities.
            </p>
            <p>
              The system is applicable across industries and public institutions. It supports governance as well as execution. It enables sustained adaptation, not one-time change.
            </p>
          </div>

          <div className="space-y-6">
            {elements?.map((element, index) => (
              <div key={index} className="bg-white border-2 border-gray-200 p-8 hover:border-[#0A2540] transition-colors duration-300">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0 w-16 h-16 bg-[#0A2540] flex items-center justify-center">
                    <span className="text-2xl font-bold text-white">{element?.number}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-[#0A2540] mb-3">
                      {element?.title}
                    </h3>
                    <p className="text-lg text-gray-800 leading-relaxed">
                      {element?.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SystemSection;